import SaasLandingPage from '../../templates/Snapshots/SaasLandingPage.png';
import eCommSnap from '../../templates/Snapshots/eCommSnap.png';
import portfolioSnap from '../../templates/Snapshots/portfolioSnap.png';
import adminDashSnap from '../../templates/Snapshots/adminDashSnap.png';
import healthCareSnap from '../../templates/Snapshots/healthCareSnap.png';
import codeShot from '../../code.png';
import previewShot from '../../preview.png';
import historyShot from '../../history.png';
import fileShot from '../../file.png';

export const LANDING_CONTENT = {
  brand: {
    name: 'DS CodeXAI',
    tagline: 'Autonomous Software Engineering Platform',
    version: 'v0.3.0',
  },
  seo: {
    title: 'DS CodexAI | AI Coding Assistant & AI Coding Tools',
    description:
      'Looking for AI for coding? DSCodex AI helps developers write, understand, debug, and improve code with an AI-powered code assistant.',
    url: 'https://dscodexai.com',
  },
  nav: [
    { id: 'home', label: 'Home', scrollTo: 'home' },
    { id: 'how-it-works', label: 'How It Works', scrollTo: 'how-it-works' },
    { id: 'workflow', label: 'Workflow', scrollTo: 'workflow' },
    { id: 'workspace', label: 'Workspace', scrollTo: 'workspace' },
    { id: 'templates', label: 'Templates', scrollTo: 'templates' },
    { id: 'blog', label: 'Blog', scrollTo: 'blog' },
    { id: 'pricing', label: 'Pricing', scrollTo: 'pricing' },
  ],
  hero: {
    headline: ['Turn Software','Ideas Into','Production Systems','With CodeXAI.'],
    highlightLine: 1,
    subheadline:
      'Your fully autonomous engineer. CodeXAI coding assistant transforms PRDs into full-stack applications so engineering teams build faster with no development overhead.',
    ctaPrimary: 'Launch Free Workspace',
    ctaSecondary: 'Explore Live Demo',
    trust: ['11 Specialized Agents', '10 Professional Templates', 'Multi-Stack Development', 'Self-Hosted Ready'],
    executionProjects: [
      {
        request: 'Build a SaaS analytics platform',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['React Frontend', 'Node.js Backend', 'Authentication Included', 'Deployment Configured'],
        },
      },
      {
        request: 'Create an HR management system',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['Vue Frontend', 'Python Backend', 'RBAC Included', 'Deployment Configured'],
        },
      },
      {
        request: 'Generate a CRM dashboard',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['React Frontend', 'Node.js API', 'Charts & Metrics', 'Deployment Configured'],
        },
      },
      {
        request: 'Build an e-commerce storefront',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['Next.js Storefront', 'Payment APIs', 'Inventory Module', 'Deployment Configured'],
        },
      },
      {
        request: 'Create a customer support portal',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['React Frontend', 'Ticket APIs', 'Live Chat Module', 'Deployment Configured'],
        },
      },
      {
        request: 'Generate a project management platform',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['React Frontend', 'FastAPI Backend', 'Kanban Board', 'Deployment Configured'],
        },
      },
      {
        request: 'Build an inventory management system',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['Vue Frontend', 'Go Backend', 'Stock Tracking', 'Deployment Configured'],
        },
      },
      {
        request: 'Create a healthcare appointment system',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['React Frontend', 'FastAPI Backend', 'Booking Engine', 'Deployment Configured'],
        },
      },
      {
        request: 'Generate a learning management platform',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['React Frontend', 'Django Backend', 'Course Engine', 'Deployment Configured'],
        },
      },
      {
        request: 'Build a finance dashboard',
        steps: [
          'Requirements Analyzed',
          'Architecture Planned',
          'Frontend Generated',
          'Backend Generated',
          'Validation Running',
          'Deployment Ready',
        ],
        output: {
          title: 'Project Ready',
          items: ['React Frontend', 'Node.js API', 'Analytics Charts', 'Deployment Configured'],
        },
      },
    ],
  },
  featureStory: {
    label: 'HOW YOU WORK WITH IT',
    title: 'The four-stage transition from initial idea to production-ready product.',
    description: '',
    cards: [
      {
        id: 'describe',
        title: 'Plan with Accuracy',
        description: 'Start with just one prompt and our AI coding tool constructs structured blueprints with full execution steps automatically.',
        prompt: 'Build a CRM with dashboard and analytics',
        steps: ['Understanding Request', 'Analyzing Requirements', 'Designing Architecture', 'Preparing Execution Plan', 'Plan Complete'],
      },
      {
        id: 'parallel',
        title: 'Develop it in parallel',
        description: 'Frontend and backend services execute at the same time through parallel synchronized workflows for the fastest yet most accurate development possible.',
        footer: 'Synchronized Output',
      },
      {
        id: 'ship',
        title: 'Deploy on any platform',
        description: 'Connect directly with Git repositories using cloud deployment pipelines or custom self-hosted infrastructure as per your requirements.',
        stages: ['Repository', 'Build', 'Deploy', 'Production'],
        footer: 'Ready for Release',
      },
      {
        id: 'workspace',
        title: 'Iterate on one canvas',
        description: 'Review real-time previews of output and code alongside interactive chat to refine generated code continuously inside a unified workspace.',
        syncStatus: 'Synced',
      },
    ],
  },
  workflow: {
    label: 'The Pipeline Overview',
    title: 'An end-to-end autonomous pipeline engineers your complete modern apps.',
    intro: '',
    capabilities: [],
    stages: [
      {
        id: 'requirements',
        title: 'Initiating Planning',
        copy: 'Studies user requirements and generates structural implementation specs to work on.',
      },
      {
        id: 'architecture',
        title: 'Designing Architecture',
        copy: 'Designs responsive UI systems and scalable components for projects.',
      },
      {
        id: 'frontend',
        title: 'Building Frontend',
        copy: 'Generating interactive client interfaces complying with modern frameworks.',
      },
      {
        id: 'backend',
        title: 'Building Backend',
        copy: 'Building secure API services with persistent databases.',
      },
      {
        id: 'testing',
        title: 'Automated Testing',
        copy: 'Run rigorous unit tests to verify full system stability.',
      },
      {
        id: 'deployment',
        title: 'Automatic Deployment',
        copy: 'Ship code seamlessly through automated continuous delivery pipelines.',
      },
    ],
  },
  pipeline: {
    title: '11-Agent Delivery Pipeline',
    steps: [
      'PRD', 'PM', 'Architect', 'Frontend', 'Backend', 'QA',
      'Debugger', 'Validator', 'Reviewer', 'Tests', 'DevOps', 'Deploy',
    ],
    highlights: [
      'Auto-Fix Recovery',
      'Up to 5 Repair Attempts',
      'Sandbox Execution',
      'Continuous Validation',
      'Security Review',
    ],
    cta: 'Explore Workspace',
  },
  benefits: {
    title: 'Why teams choose AI Code Agent',
    items: [
      { title: 'Natural Language Development', copy: 'Describe requirements and generate applications.' },
      { title: 'Production Ready Output', copy: 'Validation, testing, security scanning.' },
      { title: 'Professional Templates', copy: 'Start from polished foundations.' },
      { title: 'Repository Import', copy: 'Import existing Git repositories.' },
      { title: 'Multi-Stack Development', copy: 'React, Vue, Node, Python, Java, Go.' },
      { title: 'Self Hosted Control', copy: 'Run on your infrastructure.' },
    ],
  },
  platform: {
    label: 'Workspace Purpose',
    title: 'Unified workspace for modern software teams to plan, build, validate, and deploy.',
    intro: 'Empower software teams with CodeXAI’s AI-powered workspace that brings the entire development workflow together.',
    cards: [
      {
        id: 'orchestration',
        title: 'Agent Orchestration',
        copy: 'Synchronize planning, execution, and validation across autonomous subagents working as your primary AI powered code assistant.',
        capabilities: ['PM', 'Architect', 'Frontend', 'Backend', 'QA', 'DevOps'],
        timeline: [
          { time: '09:42', event: 'Started' },
          { time: '09:43', event: 'Architecture' },
          { time: '09:44', event: 'Frontend' },
          { time: '09:45', event: 'Backend' },
          { time: '09:46', event: 'Validated' },
          { time: '09:47', event: 'Ready' },
        ],
      },
      {
        id: 'workspace',
        title: 'Developer Workspace',
        copy: 'Generate code, preview builds, and collaborate interactively within AI for coding environment.',
        events: ['Code Updated', 'Preview Synced', 'Chat Response', 'Build Complete'],
      },
      {
        id: 'integrations',
        title: 'Integrations',
        copy: 'Seamlessly link source control repositories, cloud hosting environments, and identity providers for top AI coding tools.',
        events: ['Repo Connected', 'OAuth Verified', 'Commit Pushed', 'Deploy Triggered'],
      },
      {
        id: 'enterprise',
        title: 'Enterprise Foundation',
        copy: 'Shield software using isolated sandboxes, validation gates, and compliance security rules.',
        verifications: ['Sandbox Active', 'Scan Passed', 'Validated', 'Approved', 'Authorized'],
      },
    ],
  },
  whyCodexAI: {
    label: 'WHY CODEXAI',
    heading: ['More than code generation.', 'A complete software delivery workflow.'],
    body: 'CodeXAI represents intelligent software creation from concept to deployment.',
    detail: 'By combining collaborative orchestration, autonomous development, validation, and execution, DS CodeXAI transforms ideas into production-ready applications through a single unified workflow.',
    pillars: ['Orchestrate', 'Build', 'Validate', 'Deploy'],
  },
  templates: {
    title: 'Launch complete web platforms fast using prebuilt modern templates',
    subtitle: 'Deploy production-ready SaaS platform apps, CRM dashboard setups, admin dashboard tools, analytics platform systems, and e-commerce store layouts instantly.',
    cta: 'Browse Templates',
    items: [
      { name: 'SaaS Platform', image: SaasLandingPage },
      { name: 'CRM Dashboard', image: adminDashSnap },
      { name: 'Admin Dashboard', image: adminDashSnap },
      { name: 'Analytics Platform', image: healthCareSnap },
      { name: 'E-Commerce Store', image: eCommSnap },
      { name: 'Portfolio Website', image: portfolioSnap },
    ],
  },
  testimonials: [
    {
      quote: 'We replaced weeks of scoping and prototyping with a single workspace. Stakeholders see live previews while the platform builds.',
      name: 'Priya Sharma',
      role: 'VP Product',
      company: 'Growth Labs',
    },
    {
      quote: 'Self-hosted deployment with sandbox isolation gives us enterprise security without slowing down iteration.',
      name: 'Marcus Chen',
      role: 'Engineering Director',
      company: 'Nova Systems',
    },
    {
      quote: 'From requirements to deployed MVP in days. The validation pipeline alone saved us countless production issues.',
      name: 'Jordan Lee',
      role: 'CTO',
      company: 'Stealth Startup',
    },
  ],
  pricing: {
    title: 'Flexible pricing tiers customized for starter builders, pro developers, and growing team environments',
    tiers: [
      {
        id: 'free',
        name: 'Free',
        description: 'For individuals exploring autonomous software creation.',
        price: 'Free',
        period: '',
        recommended: false,
        features: ['10 credits/month', '2 projects', 'Live preview', 'Download ZIP', 'gpt-4o-mini model'],
        cta: 'Get Started Free',
      },
      {
        id: 'starter',
        name: 'Starter',
        description: 'For side projects and learning.',
        price: '$19',
        period: '/mo',
        recommended: false,
        features: ['100 credits/month', '5 projects', 'Vercel deploy', 'gpt-4o model', 'Email support'],
        cta: 'Start Starter',
      },
      {
        id: 'pro',
        name: 'Pro',
        description: 'For builders shipping products faster.',
        price: '$49',
        period: '/mo',
        recommended: true,
        features: ['500 credits/month', 'Unlimited projects', 'All deploy platforms', 'Git integration', 'Priority queue', 'RAG (own codebase)'],
        cta: 'Start Pro Trial',
      },
      {
        id: 'team',
        name: 'Team',
        description: 'For collaborative software teams.',
        price: '$99',
        period: '/mo',
        recommended: false,
        features: ['2000 credits/month', 'Everything in Pro', '5 team seats', 'Admin dashboard', 'Priority support'],
        cta: 'Start Team Trial',
      },
    ],
  },
  finalCta: {
    headline: 'Build your next big product using CodeXAI',
    subheadline: 'Experience the best artificial intelligence for coding to transform software engineering for your business.',
    cta: 'Get Started Free',
  },
  footer: {
    tagline: 'Autonomous Software Engineering Platform',
    bottomLine: 'DS CodeXAI — Powered by Devstringx',
    connect: {
      title: 'Connect',
      description: '',
      links: [
        { label: 'LinkedIn', href: 'https://www.linkedin.com/company/devstringx-technologies-pvt-ltd-/' },
        { label: 'X', href: 'https://x.com/devstringx_tech' },
        { label: 'Instagram', href: 'https://www.instagram.com/devstringx' },
        { label: 'Facebook', href: 'https://www.facebook.com/devstringx' },
      ],
      phone: '+91 981 814 7186',
      email: 'info@devstringx.com',
    },
    columns: {
      Product: ['Home', 'How It Works', 'Workflow', 'Workspace', 'Templates', 'Pricing'],
      Resources: ['Documentation'],
      Legal: ['Privacy', 'Terms'],
    },
  },
};

export { codeShot, previewShot, historyShot, fileShot };
